import { Environment } from './enviroment.model';

export const defaultEnv: Environment = {
  production: false,
  endpoints: {
    api: 'http://localhost:8080/1.0',
    apiBack: 'http://localhost:8080/1.0/backend',
  }
};



// WEBPACK FOOTER //
// ./src/environments/default-env.ts